/** 
 * Type guard for filtering out null and undefined values, e.g. ['a', 'b', undefined, 'c'].filter(notEmpty)
 * 
 * Useful for getting only "valid" entities out of EntityState collections.
 */
export function notEmpty<T>(value: T | null | undefined): value is T {
    return value !== null && value !== undefined;
}
